import { render, staticRenderFns } from "./FinanceMessage.vue?vue&type=template&id=c82085b0&"
import script from "./FinanceMessage.vue?vue&type=script&setup=true&lang=js&"
export * from "./FinanceMessage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports